(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vnp-brand-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vnp-brand-directory')) {
    customElements.define('vnp-brand-directory', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        this.items = [...this.querySelectorAll('[data-vendor]')];
        this.groups = [...this.querySelectorAll('[data-group]')];
        this.links = [...this.querySelectorAll('[data-letter-link]')];
        this.input = this.querySelector('input');
        this.querySelector('[data-tools]').hidden = false;
        const normalize = text => text.normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
        this.names = new Map(this.items.map(item => [item, normalize(item.dataset.vendor)]));
        const filter = () => {
          const query = normalize(this.input.value);
          let count = 0;
          this.items.forEach(item => { item.hidden = !this.names.get(item).includes(query); if (!item.hidden) count++; });
          this.groups.forEach(group => { group.hidden = !group.querySelector('[data-vendor]:not([hidden])'); });
          this.links.forEach(link => {
            const group = this.groups.find(g => g.dataset.group === link.dataset.letterLink);
            const disabled = !group || group.hidden;
            link.setAttribute('aria-disabled', String(disabled));
            link.tabIndex = disabled ? -1 : 0;
          });
          this.querySelector('[data-count]').textContent = this.dataset.countLabel.replace('[count]', count);
          this.querySelector('[data-empty]').hidden = count !== 0;
        };
        const options = {signal: this.controller.signal};
        this.input.addEventListener('input', filter, options);
        this.input.addEventListener('search', filter, options);
        this.querySelector('[data-clear]').addEventListener('click', () => { this.input.value = ''; filter(); this.input.focus(); }, options);
        this.links.forEach(link => link.addEventListener('click', event => {
          if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
          const target = this.querySelector(link.getAttribute('href'));
          if (target) { event.preventDefault(); target.focus({preventScroll: true}); target.scrollIntoView({behavior: 'auto', block: 'start'}); }
        }, options));
        filter();
        if (this.dataset.sales === 'true') this.loadSales();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.initialized = false;
      }
      async loadSales() {
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.searchParams.set('q', '*');
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[unavailable_products]', 'show');
        url.searchParams.set('view', 'vnp-brand-sales');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const cacheKey = `vnp-brand-sales-v1:${location.host}:${this.dataset.market}:${preview || 'theme'}`;
        const vendors = new Set();
        const apply = () => {
          if (!this.isConnected) return;
          let any = false;
          this.items.forEach(item => {
            const badge = item.querySelector('[data-sale]');
            if (badge) { badge.hidden = !vendors.has(item.dataset.vendor); if (!badge.hidden) any = true; }
          });
          this.querySelector('[data-legend]').hidden = !any;
        };
        try {
          const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
          if (cached && Date.now() - cached.at < 300000 && Array.isArray(cached.vendors)) {
            cached.vendors.forEach(vendor => vendors.add(vendor)); apply(); this.dataset.saleState = 'complete'; return;
          }
        } catch {}
        const fetchPage = async page => {
          const requestUrl = new URL(url); requestUrl.searchParams.set('page', page);
          const response = await fetch(requestUrl, {credentials: 'same-origin', signal: this.controller.signal});
          if (!response.ok) throw new Error('Sale lookup failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = html.querySelector('[data-vnp-sale-data]');
          if (!payload) throw new Error('Sale data unavailable');
          const data = JSON.parse(payload.textContent);
          if (!Array.isArray(data.vendors) || data.page !== page) throw new Error('Unexpected sale data');
          data.vendors.forEach(vendor => vendors.add(vendor)); apply();
          return data;
        };
        try {
          this.dataset.saleState = 'loading';
          const first = await fetchPage(1);
          if (!Number.isInteger(first.pages) || first.pages > 100 || first.total > 25000) throw new Error('Sale pagination limit');
          let next = 2;
          const worker = async () => { while (next <= first.pages && this.isConnected) { const page = next++; await fetchPage(page); } };
          await Promise.all([worker(), worker()]);
          if (!this.isConnected) return;
          this.dataset.saleState = 'complete';
          try { sessionStorage.setItem(cacheKey, JSON.stringify({at: Date.now(), vendors: [...vendors]})); } catch {}
        } catch (error) {
          if (error.name !== 'AbortError') this.dataset.saleState = 'unavailable';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
